import { Text } from '@/ui-kit'
import clsx from 'clsx'
import { Clock } from 'lucide-react'
import { useEffect, useState } from 'react'

type AssessmentCountdownProps = {
  expiresAt: string
}

export const AssessmentCountdown = ({ expiresAt }: AssessmentCountdownProps) => {
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000))
  )

  useEffect(() => {
    const id = setInterval(() => {
      const secs = Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000))
      setRemaining(secs)
      if (secs <= 0) clearInterval(id)
    }, 1000)
    return () => clearInterval(id)
  }, [expiresAt])

  const mins = Math.floor(remaining / 60)
  const secs = remaining % 60
  const expired = remaining <= 0
  const urgent = remaining <= 120

  return (
    <Text
      type="body3-regular"
      className={clsx(
        'flex items-center gap-1 font-mono',
        expired ? 'text-red' : urgent ? 'text-orange' : 'text-gray-80'
      )}
    >
      <Clock className="size-3.5" />
      {expired ? "Time's up" : `${mins}:${secs.toString().padStart(2, '0')}`}
    </Text>
  )
}
